import React, { useEffect, useRef, useState } from "react";
import Header from "../../Header";
import "./chat.css";
import Pagination from "react-js-pagination";
import { Multiselect } from "multiselect-react-dropdown";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment, { unix } from "moment";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
// import Swal from "sweetalert2";
import PopOver from "./PopOver";
import EditorNew from "./../Editor/EditorNew";
import ChatDetailsCommon from "./ChatDetailsCommon";
import Select, { components } from "react-select";
import ReactMultiSelectCustom from "./../multiselectcustom/ReactMultiSelectCustomSearch";
import Async, { useAsync } from "react-select/async";
import { NavLink, Redirect, withRouter } from "react-router-dom";
import DynamicList from "./components/DynamicList";
import Cookies from "js-cookie";
import RsuiteChecker from "../RsuiteChecker";
import StaticList from "./components/StaticList";
import pako from "pako";
import * as actionFunction from "../../actions/common";
import {
  encodeDecodeRequest,
  retriveResponeValue,
} from "../crm/customer/Utility";
import ReactModal from "react-modal";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

function ChatTranscript({ history }) {
  const [chatList, setChatList] = useState([]);
  const [isShow, setIsShow] = useState(true);
  const [currentPage, setcurrentPage] = useState(
    (history.location &&
      history.location.state &&
      history.location.state.pageNumber) ||
    1
  );
  const params = useLocation();
  const [perPage, setperPage] = useState(20);
  const [totalCount, settotalCount] = useState(0);
  const [offSet, setoffSet] = useState(0);
  const [search, setSearch] = useState("");
  const [prodName, setprodName] = useState([]);
  const [podName, setpodName] = useState([]);
  const [asyncLoad, setAsyncLoad] = useState(false);
  const [featureName, setfeatureName] = useState([]);
  const [priority, setPriority] = useState([]);
  const [removeModal, setRemoveModal] = useState(false);
  const [highlightedColumns, setHighlightedColumns] = useState([]);
  const [filterItem, setFilterItem] = useState({});
  const [chatDetail, setChatDetail] = useState({});
  const [chatInformation, setChatInformation] = useState({});
  const [infoEdit, setInfoEdit] = useState(false);
  const [formData, setFormData] = useState({});
  const [chatNotes, setChatNotes] = useState({});
  const [noteContent, setNoteContent] = useState("");
  const [transcriptId, setTranscriptId] = useState(0);
  const [userList, setUserList] = useState({});
  const [displayIcon, setDisplayIcon] = useState(false);
  const [chatIndex, setChatIndex] = useState(0);
  const [selectText, setSelectText] = useState([]);
  const [userUUID, setUserUUID] = useState(0);
  const [highlightChat, setHighlightChat] = useState([]);
  const [chatContent, setChatContent] = useState("");
  const [rawText, setRawText] = useState("");
  const userSelection = useRef(null);
  const [currentIndex, setCurrentIndex] = useState("");
  const [activeTab, setActiveTab] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(1);
  const [tags, setTags] = useState([]);
  const [error, setError] = useState({ error: true, message: "" });
  const chatRef = useRef([]);
  const [noteAdding, setNoteAdding] = useState(0);
  const [noteError, setNoteError] = useState(false);
  const [name, setName] = useState("");
  const [feedback, setFeedback] = useState({});
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [formError, setFormError] = useState(false);
  const [feedbackData, setFeedbackData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [countries, setCountries] = useState([]);
  const [moreFilter, setMoreFilter] = useState(false);
  const [searchFilter, setSearchFilter] = useState({ key: "", value: "" });
  const [qValue, setQueryValue] = useState(null);

  const [aiChatEnabled, setAiChatEnabled] = useState(false);
  const [showAiChatModal, setShowAiChatModal] = useState(false);
  const [storePermission, setStorePermission] = useState(localStorage.getItem("store_permission"));
  const timerRef = useRef(null);
  const isFirstRender = useRef(true);

  const [sources, setSources] = useState([]);

  useEffect(() => {
    const storedUUID = Cookies.get("muvi_useruuid");
    if (storedUUID) {
      setUserUUID(storedUUID);
    }

    // Always fetch the toggle state
    fetch(`${process.env.REACT_APP_CRM}/live-chat/ai-chat-state`)
      .then((res) => res.json())
      .then((data) => {
        if (data.code === 200) {
          setAiChatEnabled(data.data.ai_chat_enabled);
        }
      })
      .catch((err) => console.error("Toggle fetch error:", err));
  }, []);

  const updateToggleState = async (enabled) => {
    const uuid = Cookies.get("muvi_useruuid");

    if (!uuid) {
      console.error("Missing user UUID");
      return;
    }

    console.log("Updating toggle to:", enabled);
    await fetch(`${process.env.REACT_APP_CRM}/live-chat/enable-ai-chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_uuid: uuid,
        ai_chat_enabled: enabled,
      }),
    });
  };

  useEffect(() => {
    window.addEventListener("mousedown", clickOutSidehandler);
    return () => {
      window.removeEventListener("mousedown", clickOutSidehandler);
    };
  }, [currentIndex]);

  const clickOutSidehandler = (e) => {
    if (
      chatRef.current[currentIndex] &&
      !chatRef.current[currentIndex].contains(e.target)
    ) {
      setDisplayIcon(false);
    } else {
      setDisplayIcon(true);
    }
  };

  // const getAttributeList = async () => {
  //   const response = await fetch(
  //     `${process.env.REACT_APP_live_chat_update}/tattle/list`,
  //     {
  //       method: "POST",
  //       body: JSON.stringify({
  //         app_token: process.env.REACT_APP_tattle_token,
  //         attribute_set_key: "live-chat",
  //         user_uuid: "da675b5a796a439d867db54b5ced81c7",
  //       }),
  //     }
  //   );

  //   const rdata = await response.json();
  //   if (rdata.code === 200) {
  //     const getval = await fetch(
  //       `${process.env.REACT_APP_live_chat_update}/tattle/rows`,
  //       {
  //         method: "POST",
  //         body: JSON.stringify({
  //           attribute_set_key: "live-chat",
  //           app_token: process.env.REACT_APP_tattle_token,
  //           // per_page: 20,
  //           // current_page: 1,
  //           user_uuid: "da675b5a796a439d867db54b5ced81c7",
  //           attribute_set_type: 20,
  //         }),
  //       }
  //     );

  //     const rdataresponse = await getval.json();
  //   }
  // };

  const getFeatureList = async (id = null) => {
    const resp = await fetch(
      `${process.env.REACT_APP_tattle_api
      }/tattle/rows/?app_token=${process.env.REACT_APP_tattle_token}&attribute_set_key=fd&search=${id || ""
      }`
    );
    if (resp.ok) {
      const resdata = await resp.json();
      if (resdata.code === 200) {
        const { data } = resdata;
        console.log("data123",data);
        const featuredata = data.map((it) => ({
          id: it.customer_tattle_uuid,
          value: it.title,
        }));
        setfeatureName(featuredata);
      }
    }
  };

  useEffect(() => {
    // getAttributeList();

    if (!localStorage.getItem("userLogin")) {
      return history.push("/login");
    }
    const userId = Cookies.get("muvi_useruuid");
    try {
      (async () => {
        const response = await fetch(process.env.REACT_APP_get_tattle_list, {
          method: "POST",
          body: JSON.stringify({
            app_token: process.env.REACT_APP_tattle_token,
            attribute_set_key: "live-chat",
            // user_uuid: "c24d106f80494c99932912a53bb5d35c",
            user_uuid: userId,
          }),
        });

        const rdata = await response.json();
        if (rdata.code === 200) {
          const { data } = rdata;
          setColumns(data.columns || []);
        }

        const countriesList = await fetch(
          `${process.env.REACT_APP_CRM}/live-chat/country/list`
        );
        const rdatar = await countriesList.json();
        setCountries(rdatar);
      })();

      fetch(`${process.env.REACT_APP_INTRANET_API}/tattle/productList`)
        .then((item) => {
          return item.json();
        })
        .then((data) => {
          setprodName(data);
        });

      fetch(`${process.env.REACT_APP_INTRANET_API}/tattle/podList`)
        .then((item) => {
          return item.json();
        })
        .then((data) => {
          setpodName(data);
        });

      fetch(`${process.env.REACT_APP_INTRANET_API}/tattle/featureList`)
        .then((item) => {
          return item.json();
        })
        .then((data) => {
          setfeatureName(data);
        });

      fetch(`${process.env.REACT_APP_CRM}/live-chat/source-list`)
        .then(res => res.json())
        .then(data => {
          const formatted = data.map((src) => ({
          id: src,
          value: src
        }));
        console.log("sources", data)
        setSources(formatted);
      });
    } catch (error) {
      console.log(error.message);
    }

    if (params) {
      const queryParams = new URLSearchParams(params.search);
      const qValue = queryParams.get("q");
      if (qValue) {
        const parsedQValue = qValue ? JSON.parse(qValue) : null;
        setFilterItem({ ...filterItem, fd: parsedQValue.fd });
        // chat(currentPage, search, { fd: parsedQValue.fd });
        getFeatureList(parsedQValue.fd);
      } else {
        getFeatureList();
        // chat(currentPage, search, null);
      }
    }

    // chat(currentPage);
    document.title = "Live Chat Transcript";
    return () => {
      document.title = "";
    };
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("userLogin")) {
      return <Redirect to="/login" />;
    }
    getUserUUID();
  }, [userList]);

  useEffect(() => {
    // Skip the first render (initial page load)
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      chat(currentPage, search, filterItem);
    }, 1000);
  }, [search])

  useEffect(() => {
    chat(currentPage, search, filterItem);
  }, [currentPage, filterItem])

  function searchHandler(e) {
    const value = e.target.value;
    setSearch(value);
    setcurrentPage(1);
  }

  function activeColumn(field) {
    return highlightedColumns.includes(field);
  }

  function resetHandler() {
    let fields = document.getElementsByClassName("input-f");
    for (let i = 0; i < fields.length; i++) {
      fields[i].value = "";
    }
    setFilterItem({});

    chat(1);
  }

  function filterHandler(e, val) {
    let filter_item = {};
    let filter_key = [...highlightedColumns, e];

    if (e == "name" || e == "agent_names" || e == "summary" || e == "id") {
      if (val.target.value == "") {
        filter_key = filter_key.filter((item) => item !== e);
      }
      filter_item = {
        [e]: val.target.value
          ? [
            val.target.value.charAt(0).toUpperCase() +
            val.target.value.slice(1),
          ]
          : null,
      };
    } else {
      filter_item = {
        [e]: val && Array.isArray(val) ? val.map((item) => item.value) : [],
      };
    }

    setFilterItem({ ...filterItem, ...filter_item });
    if (filter_key.length > 0) {
      setHighlightedColumns([...new Set([...filter_key, e])]);
    } else {
      setHighlightedColumns([...new Set([...filter_key])]);
    }

    // chat(1, null, filter_item);
  }

  function formHandler(e, val) {
    if (e === "assign_to" || e === "priority") {
      setFeedback({
        ...feedback,
        [e]: val.value,
      });
    } else {
      setFeedback({
        ...feedback,
        [e]: val.map((item) => item.value),
      });
    }
  }

  function feebackFromHandler(e, val) {
    if (e == "title") {
      setTitle(val.target.value);
    } else if (e == "description") {
      setDescription(val.target.value);
    }
  }

  function onRemoveHandler(k, e) {
    const remove_item = { [k]: e.map((item) => item.id) };
    const remove_values = Object.values(remove_item);
    let obj;
    if (remove_values.length == 0) {
      obj = { ...delete filterItem[k], ...filterItem };
    } else {
      obj = remove_item;
    }
    setHighlightedColumns(highlightedColumns.filter((item) => item !== k));
    chat(1, null, obj);
  }
  const clearDateFilter = (evt) => {
    let filters = { ...filterItem };
    filters = {
      ...filters,
      ...delete filters["date_range"],
    };
    setFilterItem(filters);
  };

  const checiFilterINput = (data) => {
    for (let key in data) {
      if (
        (data.hasOwnProperty(key) && data[key] === null) ||
        data[key] === undefined ||
        data[key] === "" ||
        (Array.isArray(data[key]) && data[key].length === 0) || // Check for empty array
        (typeof data[key] === "object" && Object.keys(data[key]).length === 0)
      ) {
        delete data[key];
      }
    }
    return data;
  };

  async function chat(current_page, search_item = null, filter_item = null) {
    if (!localStorage.getItem("userLogin")) {
      return <Redirect to="/login" />;
    }
    filter_item ? "" : setHighlightedColumns([]);
    setLoading(true);
    let filterval = {
      search,
      filter: { ...filter_item },
    };

    const searchParams = new URLSearchParams(history.location.search);
    const debug = searchParams.get("debug");
    const userUuid = Cookies.get("muvi_useruuid");
    let requests = {
      per_page: 20,
      current_page: current_page,
      ...checiFilterINput(filterval),
      user_uuid: userUuid,
    };

    if (debug) {
      requests = {
        ...requests,
        debug: true,
      };
    }
    try {
      const getval = await fetch(
        process.env.REACT_APP_CRM + `/live-chat/get-chat-list`,
        {
          method: "POST",
          body: encodeDecodeRequest(debug, requests),
        }
      );

      let rdataresponse = await retriveResponeValue(debug, getval);
      if (rdataresponse.code === 200) {
        const { data } = rdataresponse;
        setRows(data);
        setLoading(false);
        settotalCount(rdataresponse.total_count);
        setcurrentPage(current_page);
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  function handlePageChange(pageNumber = 1) {
    setcurrentPage(pageNumber);
  }

  function handleApply(evt, data) {
    let filter_item = {};
    let startDate = new Date(data.startDate).getDate();
    startDate = startDate < 10 ? `0${startDate}` : startDate;
    let endDate = new Date(data.endDate).getDate();
    endDate = endDate < 10 ? `0${endDate}` : endDate;

    let startYear = new Date(data.startDate).getFullYear();
    let endYear = new Date(data.endDate).getFullYear();

    let startMonth = new Date(data.startDate).getMonth() + 1;
    startMonth = startMonth < 10 ? `0${startMonth}` : startMonth;
    let endMonth = new Date(data.endDate).getMonth() + 1;
    endMonth = endMonth < 10 ? `0${endMonth}` : endMonth;

    let finalStartDate = `${startYear}-${startMonth}-${startDate}`;
    let finalEndDate = `${endYear}-${endMonth}-${endDate}`;

    data.element.val(
      data.startDate.format("DD-MM-YYYY") +
      " ~ " +
      data.endDate.format("DD-MM-YYYY")
    );

    filter_item = { date_range: { timestamp: [finalStartDate, finalEndDate] } };
    // chat(1, null, filter_item);
    setFilterItem({
      ...filterItem,
      ...filter_item,
    });
  }

  const closeModalHandler = () => {
    let modal = document.getElementById("full-chat-area");
    modal.classList.remove("in");
    setInfoEdit(false);
    setActiveTab(1);
  };

  const chatDetails = (id, transcript_id) => {
    setChatInformation({});
    setChatDetail({});
    setActiveTab(1);
    setShowModal(true);
    setInfoEdit(false);
    const response = fetch(
      process.env.REACT_APP_CRM + `/live-chat/chat-details`,
      {
        method: "POST",
        body: JSON.stringify({ chat_id: id }),
      }
    );
    response
      .then((data) => {
        return data.json();
      })
      .then((item) => {
        setChatDetail(item.data);
        let chatinfo = chatList.filter((ite) => ite.id == id);
        setChatInformation(chatinfo[0]);
      });

    fetch(process.env.REACT_APP_CRM + "/live-chat/get-highlight-chat", {
      method: "POST",
      body: JSON.stringify({
        chat_id: transcript_id,
      }),
    })
      .then((i) => {
        return i.json();
      })
      .then((res) => {
        if (res.code == 200) {
          setHighlightChat(res.data);
        }
      });

    setTranscriptId(transcript_id);
    getChatNotes(transcript_id);
  };

  const getChatNotes = (id) => {
    const output = fetch(
      process.env.REACT_APP_CRM + `/live-chat/get-chat-notes`,
      {
        method: "POST",
        body: JSON.stringify({
          customer_tattle_uuid: id,
        }),
      }
    );

    output
      .then((i) => {
        return i.json();
      })
      .then((out) => {
        setChatNotes(out);
      });
  };

  const saveInformation = (e) => {
    e.preventDefault();

    const {
      pod,
      product,
      feature,
      preview,
      name,
      email,
      transcript_id,
      market_feedback,
    } = formData;
    var pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (email.length == 0) {
      setError({ error: true, message: "Email Id can not be blank" });
      return false;
    } else {
      if (!email.match(pattern)) {
        setError({ error: true, message: "Please enter valid email id" });
        return false;
      } else {
        setError({ error: false, message: "" });
      }
    }

    const params = {
      transcript_id: transcript_id,
      pod: pod,
      product: product,
      market_feedback: market_feedback,
      feature: feature,
      preview: preview,
      name: name,
      email: email,
    };

    // return false;
    fetch(process.env.REACT_APP_CRM + "/live-chat/update-information", {
      method: "POST",
      body: JSON.stringify(params),
    })
      .then((res) => res.json())
      .then((item) => {
        setChatInformation({
          ...chatInformation,
          pod: pod,
          product: product,
          market_feedback: market_feedback,
          feature: feature,
          preview: preview,
          name: name,
          email: email,
        });
        setInfoEdit(!infoEdit);
        chat(currentPage);
      });
  };

  const editFormHandler = (field = null, e) => {
    const { name, value } = e.target;
    var pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (name === "email" && value.length === 0) {
      setError({ error: true, message: "Email Id can not be blank" });
    } else if (!value.match(pattern)) {
      setError({ error: true, message: "Please enter valid email Id" });
    }
    setFormData({ ...formData, [name]: value });
  };

  const editBtnHandler = () => {
    setInfoEdit(!infoEdit);
    setFormData(chatInformation);
  };

  const decrypt = (findresponse, flg) => {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  };

  const getUserUUID = () => {
    const userdetails = decrypt(localStorage.getItem("encdata"), 0);
    const data = userList;
    const emp_id = parseInt(userdetails.user_id);
    let userUuid = null;

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const user = data[key];
        if (user.emp_id === emp_id) {
          userUuid = user.user_uuid;
          break;
        }
      }
    }
    setUserUUID(userUuid);
  };

  const noteAdd = (e) => {
    e.preventDefault();
    setNoteAdding(1);
    setEditId(editId + 1);

    if (noteContent.length == 0) {
      setNoteError(true);
      setNoteAdding(0);
      return false;
    }

    if (noteContent && noteContent.chat_note.html_content == "") {
      setNoteError(true);
      setNoteAdding(0);
      return false;
    } else {
      setNoteError(false);
      setNoteContent("");
      setTimeout(() => {
        fetch(process.env.REACT_APP_CRM + `/live-chat/add-note`, {
          method: "POST",
          body: JSON.stringify({
            customer_tattle_uuid: transcriptId,
            user_uuid: userUUID,
            note_content: noteContent,
          }),
        })
          .then((item) => {
            return item.json();
          })
          .then((data) => {
            setNoteAdding(0);
            getChatNotes(transcriptId);
          });
      }, 1000);
    }
  };
  const submitSetSearch = () => {
    const filters = { ...searchFilter };
    const filtervalue = { [filters.key]: filters.value };
    setFilterItem(filtervalue);
  };

  const searchValueHandler = (evt, key) => {
    let filters = { ...searchFilter };
    if (key === "key") {
      filters = { ...filters, key: evt };
      setSearchFilter(filters);
    } else {
      const { name, value } = evt.target;
      filters = { ...filters, value: value };
      setSearchFilter(filters);
    }
  };

  //update feature
  const updateFeatureHandler = (field, evt) => {
    const formdataedit = { ...formData };
    if (field === "product") {
      formdataedit[field] = evt.map((it) => it.id);
    } else if (field === "market_feedback") {
      formdataedit[field] = evt.map((it) => it.value);
    } else if (field === "source") {
      formdataedit[field] = evt && evt.value ? evt.value : "";
    } else {
      formdataedit[field] = evt.map((it) => Number(it.id));
    }
    setFormData(formdataedit);
  };

  const onRemove = (selectedList, removedItem) => {
    setFormData({
      ...formData,
      [selectedList]: removedItem.map((item) =>
        selectedList == "feature" ? Number(item.id) : item.id
      ),
    });
  };

  const getEditForm = () => {
    return (
      <div class="information-viewarea">
        <div class="input-box">
          <form onSubmit={saveInformation}>
            <div class="infoBtn">
              <button class="informDone" type="submit">
                <span>
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_51_1921)">
                      <path
                        d="M8.49992 14.6667C12.1818 14.6667 15.1666 11.6819 15.1666 8.00001C15.1666 4.31811 12.1818 1.33334 8.49992 1.33334C4.81802 1.33334 1.83325 4.31811 1.83325 8.00001C1.83325 11.6819 4.81802 14.6667 8.49992 14.6667Z"
                        fill="#0CB9F2"
                        stroke="#0CB9F2"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M11.8332 6L7.83325 10.6667L5.83325 9"
                        stroke="#F2F2F2"
                        stroke-width="1.33"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_51_1921">
                        <rect
                          width="16"
                          height="16"
                          fill="white"
                          transform="translate(0.5)"
                        ></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                Done
              </button>
              <button
                class="informCancel"
                onClick={() => setInfoEdit(!infoEdit)}
              >
                <span>
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_51_1927)">
                      <path
                        d="M8.49992 14.6667C12.1818 14.6667 15.1666 11.6819 15.1666 8.00001C15.1666 4.31811 12.1818 1.33334 8.49992 1.33334C4.81802 1.33334 1.83325 4.31811 1.83325 8.00001C1.83325 11.6819 4.81802 14.6667 8.49992 14.6667Z"
                        fill="#666666"
                        stroke="#666666"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M10.5 6L6.5 10"
                        stroke="#F2F2F2"
                        stroke-width="1.33"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M6.5 6L10.5 10"
                        stroke="#F2F2F2"
                        stroke-width="1.33"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_51_1927">
                        <rect
                          width="16"
                          height="16"
                          fill="white"
                          transform="translate(0.5)"
                        ></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                Cancel
              </button>
            </div>

            <div class="input-box">
              <label class="input-label">Feature</label>
              <div class="bunch-span">
                <Multiselect
                  options={featureName.map((item) => {
                    return { name: item.value, id: item.id };
                  })}
                  selectedValues={featureName
                    .filter((item) => {
                      return (
                        formData.feature &&
                        formData.feature.includes(Number(item.id))
                      );
                    })
                    .map((nitem) => ({ name: nitem.value, id: nitem.id }))}
                  displayValue="name"
                  avoidHighlightFirstOption="true"
                  closeOnSelect={false}
                  onSelect={(evt) => updateFeatureHandler("feature", evt)}
                  onRemove={(evt) => onRemove("feature", evt)}
                  className="multipleselecty"
                  style={customCss}
                />
              </div>
            </div>

            <div class="input-box">
              <label class="input-label">POD</label>
              <div class="bunch-span">
                <Multiselect
                  options={podName.map((item) => {
                    return { name: item.value, id: item.id };
                  })}
                  selectedValues={podName
                    .filter((item) => {
                      return (
                        formData.pod && formData.pod.includes(Number(item.id))
                      );
                    })
                    .map((nitem) => ({ name: nitem.value, id: nitem.id }))}
                  displayValue="name"
                  avoidHighlightFirstOption="true"
                  closeOnSelect={false}
                  onSelect={(evt) => updateFeatureHandler("pod", evt)}
                  onRemove={(evt) => onRemove("pod", evt)}
                />
              </div>
            </div>

            <div class="input-box">
              <label class="input-label">Product</label>
              <div class="bunch-span">
                <Multiselect
                  options={prodName.map((item) => {
                    return { name: item.value, id: item.id };
                  })}
                  selectedValues={prodName
                    .filter((item) => {
                      return (
                        formData.product && formData.product.includes(item.id)
                      );
                    })
                    .map((nitem) => ({ name: nitem.value, id: nitem.id }))}
                  displayValue="name"
                  avoidHighlightFirstOption="true"
                  closeOnSelect={false}
                  onSelect={(evt) => updateFeatureHandler("product", evt)}
                  onRemove={(evt) => onRemove("product", evt)}
                />
              </div>
            </div>
            <div className="input-box">
              <label className="input-label">Source</label>
              <div className="bunch-span">
                <Multiselect
                  options={sources.map((item) => {
                    return { name: item.value, id: item.id };
                  })}
                  selectedValues={sources
                    .filter((item) => {
                      return (
                        formData.sources && formData.sources.includes(item.id)
                      );
                    })
                    .map((nitem) => ({ name: nitem.value, id: nitem.id }))}
                  displayValue="name"
                  avoidHighlightFirstOption="true"
                  closeOnSelect={false}
                  onSelect={(evt) => updateFeatureHandler("sources", evt)}
                  onRemove={(evt) => onRemove("sources", evt)}
                />
              </div>
            </div>

            <div class="input-box">
              <label class="input-label">Summary</label>
              <div class="bunch-span">
                <textarea
                  type="text"
                  class="form-control"
                  placeholder="Enter Summary"
                  name="preview"
                  onChange={(evt) => editFormHandler("preview", evt)}
                >
                  {formData && formData.preview}
                </textarea>
              </div>
            </div>

            <div class="input-box">
              <label class="input-label">Email ID</label>
              <div class="bunch-span">
                <input
                  type="text"
                  class="form-control"
                  id=""
                  onChange={(evt) => editFormHandler("email", evt)}
                  name="email"
                  placeholder="Enter Email ID"
                  value={formData && formData.email}
                />
                {error.error ? (
                  <label className="error-msg">{error.message}</label>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div class="input-box">
              <label class="input-label">Lead Name</label>
              <div class="bunch-span">
                <input
                  type="text"
                  class="form-control"
                  id=""
                  placeholder="Enter Lead Name"
                  onChange={(evt) => editFormHandler("name", evt)}
                  name="name"
                  value={formData && formData.name}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  };

  const getFormattedDate = () => {
    let date;
    if (chatDetail && chatDetail.timestamp) {
      date = new Date(chatDetail.timestamp);
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      });
    }
  };

  const addChatNote = (chatData) => {
    if (chatData.chat_note.hasOwnProperty("text")) {
      if (chatData.chat_note.text != "") {
        setNoteContent(chatData);
      }
    }
  };

  let chatHistory = [];
  if (chatDetail.history && chatDetail.history.length) {
    chatHistory = chatDetail.history;
  }

  let customCss = {
    chips: {
      background: "#F1FCFF",
    },
  };

  const highlightSelection = (e, chat_index) => {
    var selection = window.getSelection();
    setCurrentIndex(chat_index);
    if (selection.anchorNode) {
      var parentElement = selection.anchorNode.parentElement;
      if (parentElement) {
        var innerHTMLValue = parentElement.innerHTML;
        setRawText(innerHTMLValue);
      } else {
      }
    }

    setChatIndex(chat_index);
    // setDisplayIcon(true);
    userSelection.current = window.getSelection().getRangeAt(0);
    var safeRanges = getSafeRanges(userSelection);
    setSelectText(safeRanges);
  };

  const applyColor = () => {
    for (var i = 0; i < selectText.length; i++) {
      highlightRange(selectText[i]);
    }
    let parentEl = userSelection.current.commonAncestorContainer;
    if (parentEl.nodeType != 1) {
      parentEl = parentEl.parentNode;
    }
    setChatContent(parentEl.innerHTML);
  };

  const highlightRange = (range) => {
    var newNode = document.createElement("div");
    newNode.className = "highlights";
    newNode.setAttribute("style", "background-color: yellow; display: inline;");
    range.current && range.current.surroundContents(newNode);
  };

  const updateChat = () => {
    let params = {
      chat_index: chatIndex,
      chat_id: transcriptId,
      chat_content: chatContent,
    };
    fetch(process.env.REACT_APP_CRM + "/live-chat/update-chat", {
      method: "POST",
      body: JSON.stringify(params),
    })
      .then((item) => {
        return item.json();
      })
      .then((data) => {
        // console.log(data)
      });
  };
  const removeColor = () => {
    var elements = document.getElementsByClassName("highlights");
    for (var i = 0; i < elements.length; i++) {
      var content = elements[i].innerHTML;
      elements[i].outerHTML = content;
    }
    setChatContent(rawText);
  };

  const getSafeRanges = (dangerous) => {
    var a = dangerous.commonAncestorContainer;
    // Starts -- Work inward from the start, selecting the largest safe range
    var s = new Array(0),
      rs = new Array(0);
    if (dangerous.startContainer != a) {
      for (var i = dangerous.startContainer; i != a; i = i.parentNode) {
        s.push(i);
      }
    }
    if (s.length > 0) {
      for (var i = 0; i < s.length; i++) {
        var xs = document.createRange();
        if (i) {
          xs.setStartAfter(s[i - 1]);
          xs.setEndAfter(s[i].lastChild);
        } else {
          xs.setStart(s[i], dangerous.startOffset);
          xs.setEndAfter(
            s[i].nodeType == Node.TEXT_NODE ? s[i] : s[i].lastChild
          );
        }
        rs.push(xs);
      }
    }

    // Ends -- basically the same code reversed
    var e = new Array(0),
      re = new Array(0);
    if (dangerous.endContainer != a) {
      for (var i = dangerous.endContainer; i != a; i = i.parentNode) {
        e.push(i);
      }
    }
    if (e.length > 0) {
      for (var i = 0; i < e.length; i++) {
        var xe = document.createRange();
        if (i) {
          xe.setStartBefore(e[i].firstChild);
          xe.setEndBefore(e[i - 1]);
        } else {
          xe.setStartBefore(
            e[i].nodeType == Node.TEXT_NODE ? e[i] : e[i].firstChild
          );
          xe.setEnd(e[i], dangerous.endOffset);
        }
        re.unshift(xe);
      }
    }

    // Middle -- the uncaptured middle
    if (s.length > 0 && e.length > 0) {
      var xm = document.createRange();
      xm.setStartAfter(s[s.length - 1]);
      xm.setEndBefore(e[e.length - 1]);
    } else {
      return [dangerous];
    }

    // Concat
    rs.push(xm);
    let response = rs.concat(re);

    // Send to Console
    return response;
  };

  let newchatHistory = [];
  newchatHistory = chatHistory.map((item) => {
    let highlightchatdata =
      highlightChat &&
      highlightChat.length > 0 &&
      highlightChat.find((it) => it.index === item.index);
    if (highlightchatdata) {
      return { ...item, message: highlightchatdata.message };
    } else {
      return item;
    }
  });
  const postRef = useRef(null);
  const handleMouseUp = (e) => {
    const selection = window.getSelection();

    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const selectedNode = range.commonAncestorContainer;

      // Find the parent paragraph element
      let paragraphElement =
        selectedNode.nodeType === 3 ? selectedNode.parentNode : selectedNode;

      // Extract the text content of the paragraph
      const paragraphText = paragraphElement.textContent;

      setRawText(paragraphText);
    }
    const selectedText = `${window.getSelection().toString()}`;
    if (selectedText.length > 0) {
      setDisplayIcon(true);
    } else {
      setDisplayIcon(false);
    }
  };

  function showAdvFilter(e, divId) {
    e.preventDefault();
    if (divId == "adv_filter") {
      setShowFilter(!showFilter);
    }

    const button = document.getElementById("toggle-btnf");
    const range = document.createRange();
    range.selectNodeContents(button);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  function submitFeedback() {
    if (title.length === 0 || description.length === 0) {
      setFormError(true);
      return false;
    } else {
      setFormError(false);
    }

    const params = {
      app_token: process.env.REACT_APP_tattle_token,
      user_uuid: userUUID,
      attribute_set_key: "market-feedback",
      attribute_set_type: 1,
      ...feedback,
      title,
      description,
      customer_name: name,
      feedback_source: ["64d4e387a74f2d2b9109e063"],
      live_chat: [transcriptId],
    };
    setFeedback({});
    setTitle("");
    setDescription("");
    fetch(process.env.REACT_APP_tattle_api + `/tattle/create`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    })
      .then((res) => res.json())
      .then((dat) => {
        document.getElementById("addMarketFeedback").style.display = "none";
        document.querySelector(".modal-backdrop").style.display = "none";
      });
  }

  const InputOption = ({
    getStyles,
    Icon,
    isDisabled,
    isFocused,
    isSelected,
    children,
    innerProps,
    ...rest
  }) => {
    // styles
    let bg = "transparent";
    if (isFocused) bg = "#f4f7fc";

    const style = {
      alignItems: "center",
      backgroundColor: bg,
      color: "inherit",
      display: "flex ",
    };

    // prop assignment
    const props = {
      ...innerProps,
      style,
    };

    return (
      <components.Option
        {...rest}
        isDisabled={isDisabled}
        isFocused={isFocused}
        isSelected={isSelected}
        getStyles={getStyles}
        innerProps={props}
      >
        <input
          type="checkbox"
          checked={isSelected}
          style={{ marginRight: "5px", marginTop: "0px" }}
        />
        {children}
      </components.Option>
    );
  };

  async function feedbackAsyncCall(evt) {
    return await fetch(
      process.env.REACT_APP_tattle_api +
      `/tattle/rows/?app_token=${process.env.REACT_APP_tattle_token}&attribute_set_key=ideas&search=${evt}`
    )
      .then((resp) => {
        return resp.json();
      })
      .then((i) => {
        let records = i.data.map((item) => {
          return {
            label: `${item.customer_tattle_uuid} - ${item.title}`,
            value: item.customer_tattle_uuid,
          };
        });
        setFeedbackData(records);
        return records;
      });
  }

  const getReactSelectData = (formDataUpdated) => {
    setFilterItem({ ...filterItem, ...formDataUpdated });
  };

  const onChangeHandler = (evt, field) => {
    let filterItemSearch = { ...filterItem };

    if (field == "chat_type" && evt && evt == "all") {
      // If 'All' is selected, remove the field
      delete filterItemSearch[field];
      setFilterItem(filterItemSearch);
      return;
    }

    if (Array.isArray(evt)) {
      // Check if it's an array of {label, value}
      if (evt.length > 0 && typeof evt[0] === "object" && evt[0].value !== undefined) {
        filterItemSearch[field] = evt.map((item) => item.value);
      } else {
        filterItemSearch[field] = evt; // Already values
      }
    } else {
      filterItemSearch[field] = evt;
    }

    setFilterItem(filterItemSearch);
  };

  const syncCallFunction = async (evt) => {
    setAsyncLoad(true);
    const respone = await fetch(
      process.env.REACT_APP_tattle_api +
      `/tattle/rows/?app_token=${process.env.REACT_APP_tattle_token
      }&attribute_set_key=ideas&search=${evt || ""}`
    )
      .then((resp) => {
        return resp.json();
      })
      .then((i) => {
        if (i.hasOwnProperty("data")) {
          setAsyncLoad(false);
          let records = i.data.map((item) => {
            return {
              label: `${item.customer_tattle_uuid} - ${item.title}`,
              value: item.customer_tattle_uuid,
            };
          });
          setFeedbackData(records);
          return records;
        }
      });
  };

  function getFilter() {
    return (
      <div
        id="adv_filter"
        class={`adv_filter filter-wrap ${showFilter ? "show" : ""} `}
      >
        <div class="containerfull">
          <div class="row">
            <div class="col-md-3 col-lg-3">
              <div class="input-box">
                <label class="input-label">Product</label>
                <RsuiteChecker
                  data={prodName || []}
                  onChange={onChangeHandler}
                  field_name="product"
                  val={filterItem.product && filterItem.product}
                />
              </div>
            </div>
            <div class="col-md-3 col-lg-3">
              <div class="input-box">
                <label class="input-label">Pod</label>
                <RsuiteChecker
                  data={podName || []}
                  onChange={onChangeHandler}
                  field_name="pod"
                  val={filterItem.pod && filterItem.pod}
                />
              </div>
            </div>
            <div class="col-md-3 col-lg-3">
              <div class="input-box">
                <label class="input-label">Feature</label>
                <RsuiteChecker
                  data={featureName || []}
                  onChange={onChangeHandler}
                  val={filterItem.feature && filterItem.feature}
                  field_name="feature"
                />
              </div>
            </div>
            <div class="col-md-3 col-lg-3">
              <div class="input-box">
                <label class="input-label">Date</label>
                <DateRangePicker
                  initialSettings={{
                    showDropdowns: true,
                    autoUpdateInput: false,
                    linkedCalendars: false,
                    locale: { cancelLabel: "Clear" },
                  }}
                  onApply={(evt, picker) => handleApply(evt, picker)}
                  onCancel={(evt) => {
                    clearDateFilter(evt);
                    evt.target.value = "";
                  }}
                >
                  <input
                    className="form-control input-f date-box"
                    name="date_range"
                    defaultValue=""
                    placeholder="From Date - To Date"
                    autoComplete="off"
                  />
                </DateRangePicker>
              </div>
            </div>
            <div class="col-md-12 col-lg-12 d-flex gap-4 gap-8" style={{ gap: "8px" }}>
              <div class="" style={{ flex: 1 }}>
                <div class="input-box tag-box">
                  <label class="input-label">Source</label>
                  <div class="w-100">
                    <RsuiteChecker
                      data={sources || []}
                      onChange={onChangeHandler}
                      field_name="campaign_source"
                      val={filterItem.campaign_source && filterItem.campaign_source}
                    />
                    {/* <Select
                      // onChange={(selected) => {
                      //   console.log("🔍 Selected source value:", selected);
                      //   onChangeHandler(
                      //     selected ? selected.map((item) => item.value) : [],
                      //     "sources"
                      //   );
                      // }}
                      value={
                        filterItem.sources
                          ? filterItem.sources.map((s) => ({ label: s, value: s }))
                          : []
                      }
                    /> */}
                  </div>
                </div>
              </div>
              <div class="" style={{ flex: 1 }}>
                <div class="input-box tag-box">
                  <label class="input-label">Visitor</label>
                  <div class="w-100">
                    <div class="text_filter dropdown bootstrap-select show-tick productselect bs3">
                      <RsuiteChecker
                        data={
                          [
                            { value: "With Email", id: "withmail" },
                            { value: "Without Email", id: "withoutmail" },
                          ] || []
                        }
                        val={filterItem.visitor && filterItem.visitor}
                        select={true}
                        onChange={onChangeHandler}
                        field_name="visitor"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/*<div class="" style={{ flex: 1 }}>
                <div class="input-box tag-box">
                  <label class="input-label">Country</label>
                  <div class="w-100">
                    <div class="text_filter dropdown bootstrap-select show-tick productselect bs3">
                      <RsuiteChecker
                        data={countries.map((item) => ({
                          value:
                            item.name.charAt(0).toUpperCase() + item.name.length >
                            20
                              ? item.name.charAt(0).toUpperCase() +
                                item.name.slice(1, 15).toLowerCase() +
                                "..."
                              : item.name.charAt(0).toUpperCase() +
                                item.name
                                  .slice(1, item.name.length)
                                  .toLowerCase(),
                          id: item.name,
                        }))}
                        val={filterItem.country && filterItem.country}
                        select={true}
                        searchable={true}
                        onChange={onChangeHandler}
                        field_name="country"
                      />
                    </div>
                  </div>
                </div>
                      </div>*/}
              <div class="" style={{ flex: 1 }}>
                <div class="input-box tag-box">
                  <label class="input-label">Department</label>
                  <div class="w-100">
                    <div class="text_filter dropdown bootstrap-select show-tick productselect bs3">
                      <RsuiteChecker
                        data={
                          [
                            { value: "Cms", id: "CMS" },
                            { value: "Extranet", id: "Extranet" },
                          ] || []
                        }
                        val={
                          filterItem.department_name && filterItem.department_name
                        }
                        select={true}
                        onChange={onChangeHandler}
                        field_name="department_name"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="" style={{ flex: 1 }}>
                <div class="input-box tag-box">
                  <label class="input-label">Platform</label>
                  <div class="w-100">
                    <RsuiteChecker
                      data={
                          [
                            { value: "All", id: "all"},
                            { value: "Zoho SalesIQ", id: "zoho" },
                            { value: "Alie", id: "ai" },
                          ] || []
                      }
                      val={filterItem.chat_type ? filterItem.chat_type : "all"}
                      select={true}
                      onChange={onChangeHandler}
                      field_name="chat_type"
                    />
                  </div>
                </div>
              </div>
              <div class="" style={{ flex: 1 }}>
                <div class="input-box tag-box">
                  <label class="input-label">Chat Feedback</label>
                  <div class="w-100">
                    <RsuiteChecker
                      data={
                          [
                            { value: "Very Good", id: "very_good"},
                            { value: "Good", id: "good" },
                            { value: "Average", id: "average" },
                            { value: "Bad", id: "bad" },
                            { value: "Very Bad", id: "very_bad" },
                          ] || []
                      }
                      val={filterItem.reaction ? filterItem.reaction : "all"}
                      select={true}
                      onChange={onChangeHandler}
                      field_name="reaction"
                    />
                  </div>
                </div>
              </div>
            </div>
            {!moreFilter && (
              <div
                className="col-md-3 col-lg-3 more_filter-ui"
                onClick={() => setMoreFilter(true)}
              >
                <label htmlFor=""></label>
                <div class="more-btn btn-blue">More Filter</div>
              </div>
            )}
          </div>
          {moreFilter && (
            <div className="row">
              <div class="col-md-3 col-lg-3">
                <div class="input-box tag-box">
                  <label class="input-label">Column Name</label>
                  <div class="w-100">
                    <div class="text_filter dropdown bootstrap-select show-tick productselect bs3">
                      <RsuiteChecker
                        data={
                          columns.map((item) => ({
                            value: item.headerName,
                            id: item.field,
                          })) || []
                        }
                        // val={
                        //   filterItem.department_name &&
                        //   filterItem.department_name
                        // }

                        onChange={(evt) => searchValueHandler(evt, "key")}
                        field_name="department_name"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-lg-3">
                <div class="input-box tag-box">
                  <label class="input-label">Value</label>
                  <div class="w-100">
                    <div class="text_filter dropdown bootstrap-select show-tick productselect bs3 search_value_search">
                      {searchFilter["value"] && (
                        <div className="remove-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="size-6"
                            width="19px"
                            onClick={() =>
                              setSearchFilter((state) => {
                                return { ...state, value: "" };
                              })
                            }
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                            />
                          </svg>
                        </div>
                      )}
                      <input
                        type="text"
                        name=""
                        onChange={(evt) => searchValueHandler(evt, "val")}
                        placeholder="Search by value"
                        id=""
                        value={searchFilter["value"] || ""}
                        className="form-control show-more-filter-text"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-lg-3 ">
                <label htmlFor=""></label>
                <div className="more_filter-ui-less">
                  <div
                    class="more-btn btn-blue more_filter-ui-search"
                    onClick={submitSetSearch}
                  >
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 18 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.25 14.75C11.5637 14.75 14.25 12.0637 14.25 8.75C14.25 5.43629 11.5637 2.75 8.25 2.75C4.93629 2.75 2.25 5.43629 2.25 8.75C2.25 12.0637 4.93629 14.75 8.25 14.75Z"
                        stroke="white"
                        stroke-width="1.33"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M15.75 16.25L12.4875 12.9875"
                        stroke="white"
                        stroke-width="1.33"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>{" "}
                    &nbsp; Search
                  </div>
                  <div
                    class="more-btn btn-blue  "
                    onClick={() => setMoreFilter(false)}
                  >
                    Less Filter
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header
        brecum_name="Live Chat Transcript"
        brecum_page="Live Chat Transcript"
      />

      <div class="right_col">
        {/* Chat popup */}
        <ChatDetailsCommon
          showModal={showModal}
          refff={chatRef}
          closeModalHandler={() => setShowModal(!showModal)}
          transcriptId={transcriptId}
          chatDetail={chatDetail}
          getFormattedDate={getFormattedDate}
          highlightSelection={highlightSelection}
          handleMouseUp={handleMouseUp}
          displayIcon={displayIcon}
          chatIndex={chatIndex}
          userUUID={userUUID}
          applyColor={applyColor}
          userList={userList}
          getChatNotes={getChatNotes}
          setDisplayIcon={setDisplayIcon}
          updateChat={updateChat}
          chatContent={chatContent}
          addChatNote={addChatNote}
          noteAdd={noteAdd}
          chatNotes={chatNotes}
          infoEdit={infoEdit}
          editBtnHandler={editBtnHandler}
          chatInformation={chatInformation}
          featureName={featureName}
          podName={podName}
          prodName={prodName}
          getEditForm={getEditForm}
          newchatHistory={newchatHistory}
          removeColor={removeColor}
          activeTab={activeTab}
          editId={editId}
          noteError={noteError}
          noteAdding={noteAdding}
        />

        <div class="customer-wrap">
          <div class="page-top">
            <div class="containerfull">
              <div class="row">
                <div class="col-md-4">
                  <div class="row">
                    <div class="col-md-8">
                      <div class="mt-10">
                        <div class="d-flex align-items-center">
                          <h2>Chat Transcript</h2>
                          <span class="badge-blue">{totalCount}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-8 p-0">
                  <div class="d-flex">
                    <div className="col-md-3 d-flex align-items-center justify-content-end">
                      <div className="ai-toggle d-flex align-items-center me-4">
                        <span className="toggle-label ml-2">AI Chat</span>
                          <label
                           className="switch m-0"
                           title={storePermission != 1 ? "You do not have permission to make the switch." : ""}
                          >
                            <input
                              type="checkbox"
                              checked={aiChatEnabled}
                              disabled={storePermission != 1}
                              onChange={() => {
                                if (storePermission != 1) {
                                  console.log("User does not have permission to toggle AI Chat");
                                  return;
                                }
                                if (!aiChatEnabled) {
                                  console.log("Toggling ON: show modal");
                                  setShowAiChatModal(true);
                                } else {
                                  console.log("Toggling OFF: disable AI chat");
                                  setAiChatEnabled(false);
                                  updateToggleState(false);
                                }
                              }}
                            />
                            <span 
                              className="slider round"
                              style={storePermission != 1 ? {cursor: "not-allowed", opacity: "0.6"} : {}}
                            ></span>
                          </label>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <div className="d-flex">
                          <div class="lct-form-group">
                          <input
                            placeholder="Search ID or Summary or Name or Email or Agent Name"
                            type="text"
                            class="form-control input-f"
                            name="customer"
                            id="customer"
                            autoComplete="off"
                            onChange={searchHandler}
                          />
                          <button type="submit">
                            <svg
                              width="18"
                              height="19"
                              viewBox="0 0 18 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.25 14.75C11.5637 14.75 14.25 12.0637 14.25 8.75C14.25 5.43629 11.5637 2.75 8.25 2.75C4.93629 2.75 2.25 5.43629 2.25 8.75C2.25 12.0637 4.93629 14.75 8.25 14.75Z"
                                stroke="white"
                                stroke-width="1.33"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                              <path
                                d="M15.75 16.25L12.4875 12.9875"
                                stroke="white"
                                stroke-width="1.33"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                            </svg>
                          </button>
                        </div>
                        <div
                          id="toggle-btnf"
                          class={
                            "toogle-btn" + (showFilter ? " collapse-state" : "")
                          }
                          onClick={(e) => showAdvFilter(e, "adv_filter")}
                        >
                          <svg
                            width="20"
                            height="17"
                            viewBox="0 0 20 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.83333 12.5H11.1667V11.3571H7.83333V12.5ZM4.5 9.07143H14.5V7.92857H4.5V9.07143ZM2 4.5V5.64286H17V4.5H2Z"
                              fill="#303049"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showFilter ? getFilter() : ""}
          {/* <--modal start for Credit Leave-!> */}
          <div class="modal fade" id="addMarketFeedback" role="dialog">
            <div class="modal-dialog modal-md">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal">
                    &times;
                  </button>
                  <h4 style={{ color: "black" }} class="modal-title">
                    Add Ideas{" "}
                  </h4>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12 form-group">
                      <label for="reward-title">
                        Title <span class="error-msg">*</span>{" "}
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        name="title"
                        placeholder="Title"
                        onChange={(evt) => feebackFromHandler("title", evt)}
                      />
                      {formError && title.length === 0 && (
                        <label className="error-msg">
                          Please fill the field
                        </label>
                      )}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12 form-group">
                      <label for="reward-title">
                        Description <span class="error-msg">*</span>
                      </label>
                      <textarea
                        name="description"
                        class="form-control"
                        rows={3}
                        onChange={(evt) =>
                          feebackFromHandler("description", evt)
                        }
                      ></textarea>
                      {formError && description.length === 0 && (
                        <label className="error-msg">
                          Please fill the field
                        </label>
                      )}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 form-group">
                      <label for="reward-title">Priority</label>
                      <Select
                        className="multi-select"
                        classNamePrefix="multi-select"
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        options={priority.map((item) => {
                          return { label: item.option_name, value: item._id };
                        })}
                        displayValue="label"
                        closeOnSelect={false}
                        onChange={(e) => formHandler("priority", e)}
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label for="reward-title">Assign To</label>
                      <Select
                        className="multi-select"
                        classNamePrefix="multi-select"
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        options={Object.keys(userList).map((item) => {
                          return {
                            label: userList[item].name,
                            value: userList[item].user_uuid,
                          };
                        })}
                        displayValue="label"
                        closeOnSelect={false}
                        onChange={(e) => formHandler("assign_to", e)}
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 form-group">
                      <label for="reward-title">Customer Name</label>
                      <input
                        type="text"
                        class="form-control"
                        name="reward_name"
                        placeholder="Customer Name"
                        value={name}
                        readOnly
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label for="reward-title">POD</label>
                      <Select
                        isMulti
                        className="multi-select"
                        classNamePrefix="multi-select"
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        options={podName.map((item) => {
                          return { label: item.value, value: item.id };
                        })}
                        displayValue="label"
                        closeOnSelect={false}
                        onChange={(e) => formHandler("pod", e)}
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 form-group">
                      <label for="reward-title">Product</label>
                      <Select
                        isMulti
                        className="multi-select"
                        classNamePrefix="multi-select"
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        options={prodName.map((item) => {
                          return { label: item.value, value: item.id };
                        })}
                        displayValue="label"
                        closeOnSelect={false}
                        onChange={(e) => formHandler("product", e)}
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label for="reward-title">Feature</label>
                      <Select
                        isMulti
                        className="multi-select"
                        classNamePrefix="multi-select"
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        options={featureName.map((item) => {
                          return { value: item.id, label: item.value };
                        })}
                        displayValue="label"
                        closeOnSelect={false}
                        onChange={(e) => formHandler("feature", e)}
                      />
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-blue"
                    data-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="btn btn-sky"
                    id="credit_leave"
                    onClick={() => submitFeedback()}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
          <StaticList
            columnsData={columns || []}
            rowsData={rows || []}
            loading={loading}
            currentPage={currentPage}
          />
          {totalCount > 0 ? (
            <div
              class="d-flex mu-pagination justify-content-between align-items-center"
              aria-label="Page navigation example"
            >
              <div class="txt-dark">
                Showing {offSet + 1 + " - " + (offSet + perPage)} of{" "}
                {totalCount}
              </div>
              <div class="mu-pagination">
                <Pagination
                  activePage={currentPage}
                  itemsCountPerPage={20}
                  totalItemsCount={totalCount}
                  pageRangeDisplayed={5}
                  itemClass="page-item"
                  linkClass="page-link"
                  onChange={handlePageChange}
                />
              </div>
            </div>
          ) : (
            ""
          )}
          <ReactModal
            isOpen={showAiChatModal}
            onRequestClose={() => setShowAiChatModal(false)}
            className="styled-modal"
            overlayClassName="styled-modal-overlay"
            ariaHideApp={false}
          >
            <div className="p-4">
              <h5 className="fw-semibold mb-3">Switch to AI Chat</h5>
              <p className="text-muted mb-4">
                Are you sure you want to switch to AI chat? <br />
                Your conversation will now be handled by our AI agent.
              </p>

              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => setShowAiChatModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setAiChatEnabled(true);
                    updateToggleState(true);
                    setShowAiChatModal(false);
                  }}
                >
                  Switch
                </button>
              </div>

            </div>
          </ReactModal>
        </div>
      </div>
    </div>
  );
}

export default withRouter(ChatTranscript);



// WEBPACK FOOTER //
// ./src/components/chat/ChatTranscript.js